module.exports = __webpack_public_path__ + "img/3.56f76eb5.png";